import { ModelType } from '@/modules/core/app/constants/ModelType';

export class SpotlightSearchParams {
  q?: string;
  limit?: number;
  onlyTrashed?: boolean;
  onlyClosed?: boolean;
  userHasEstateAccount?: boolean;
  modelType?: ModelType;

  setSearchQuery(value: string): void {
    this.q = value;
  }

  setLimit(value: number): void {
    this.limit = value;
  }

  setOnlyTrashed(value: boolean): void {
    this.onlyTrashed = value;
  }

  setOnlyClosed(value: boolean): void {
    this.onlyClosed = value;
  }

  setUserHasEstateAccount(value: boolean): void {
    this.userHasEstateAccount = value;
  }

  setModelType(value: ModelType): void {
    this.modelType = value;
  }
}
